import { ProjectTemplateRateTableBase } from './base/project-template-rate-table-base';

export class ProjectTemplateRateTable extends ProjectTemplateRateTableBase { }